import {
  BitkitIconComponent,
  IconBazel,
  IconFlutter,
  IconGradle,
  IconMoreHorizontal,
  IconReact,
  IconTrigger,
  IconXcode,
} from '@bitrise/bitkit-v2';

export enum BuildCacheToolIds {
  gradle = 'gradle',
  bazel = 'bazel',
  reactNative = 'react-native',
  flutter = 'flutter',
  xcode = 'xcode',
  other = 'other',
  ccache = 'ccache',
}

export type BuildCacheTool = {
  id: BuildCacheToolIds;
  name: string;
  iconComponent: BitkitIconComponent;
};

export const buildCacheToolGradle: BuildCacheTool = {
  id: BuildCacheToolIds.gradle,
  name: 'Gradle',
  iconComponent: IconGradle,
};

export const buildCacheToolBazel: BuildCacheTool = {
  id: BuildCacheToolIds.bazel,
  name: 'Bazel',
  iconComponent: IconBazel,
};

export const buildCacheToolReactNative: BuildCacheTool = {
  id: BuildCacheToolIds.reactNative,
  name: 'React Native',
  iconComponent: IconReact,
};
export const buildCacheToolFlutter: BuildCacheTool = {
  id: BuildCacheToolIds.flutter,
  name: 'Flutter',
  iconComponent: IconFlutter,
};
export const buildCacheToolXcode: BuildCacheTool = {
  id: BuildCacheToolIds.xcode,
  name: 'Xcode',
  iconComponent: IconXcode,
};

export const buildCacheToolOther: BuildCacheTool = {
  id: BuildCacheToolIds.other,
  name: 'Other',
  iconComponent: IconMoreHorizontal,
};

const buildCacheToolCCache: BuildCacheTool = {
  id: BuildCacheToolIds.ccache,
  name: 'Ccache',
  iconComponent: IconTrigger,
};

export const supportedBuildCacheTools = {
  [BuildCacheToolIds.gradle]: buildCacheToolGradle,
  [BuildCacheToolIds.bazel]: buildCacheToolBazel,
  [BuildCacheToolIds.xcode]: buildCacheToolXcode,
  [BuildCacheToolIds.reactNative]: buildCacheToolReactNative,
};

export const buildCacheTools = {
  ...supportedBuildCacheTools,
  [BuildCacheToolIds.flutter]: buildCacheToolFlutter,
  [BuildCacheToolIds.other]: buildCacheToolOther,
  [BuildCacheToolIds.ccache]: buildCacheToolCCache,
};
